// extracted by mini-css-extract-plugin
export default {"ServicesInventionsApplication":"Application_ServicesInventionsApplication__f3apu"};